/** The API refuses a NEW sign-in that is not the company's single sign-on (password, Google, Microsoft) when the
 * email's company signs in with SSO: 403 with problem code `sso_required` and the `email`. Pure (node --test). */
export interface SsoRequired {
  /** The email to start the company sign-in for (the problem's, else the signed-in token's); null if neither. */
  email: string | null;
}

export function ssoRequired(error: unknown, fallbackEmail?: string | null): SsoRequired | null {
  if (!error || typeof error !== "object") return null;
  const { status, problem } = error as { status?: unknown; problem?: { code?: unknown; email?: unknown } | null };
  if (status !== 403 || !problem || problem.code !== "sso_required") return null;
  const email = typeof problem.email === "string" && problem.email.includes("@") ? problem.email : fallbackEmail;
  return { email: email ? email.trim().toLowerCase() : null };
}
